import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { track } from '@xanadu/ui-shared/interfaces/woopra';
// eslint-disable-next-line import/extensions
import styles from './NotFound.module.scss';

export default class NotFound extends PureComponent {
  componentDidMount() {
    track('Marketing', 'Page Not Found', {
      description: location.href
    });
  }

  render() {
    return (
      <div className={styles.notFound}>
        <Helmet>
          <title>Page Not Found</title>
          <meta name="description" content="" />
        </Helmet>
        <img src="/assets/images/logo.svg" className={styles.logo} alt="logo" />
        <div className={styles.title}>Page Not Found</div>
        <div className={styles.text}>
          <p>Sorry, odds are that the page you are looking for does not exist.</p>
          <p>
            <a
              className={styles.link}
              href="/"
            >
              Return to Homepage?
            </a>
          </p>
          <p className={styles['text-small']}>Licensed and Regulated by the
            <Link
              className={styles.link}
              to="https://secure.gamblingcommission.gov.uk/gccustomweb/PublicRegister/PRSearch.aspx?ExternalAccountId=39504"
              target="_blank"
              rel="noopener noreferrer"
              title="UK Gambling Commission"
            >
              &nbsp;UK Gambling Commission.&nbsp;
            </Link>
            &copy;Triplebet Limited. All right reserved. Inchalla, Le Val, Alderney,
            GY9 3UL. Company Registration Number: 1827.
          </p>
        </div>
      </div>
    );
  }
}
